<template>
  <div>
    <div id="works" ref="works">
      <navigator-work
        label="Obra | Work"
        section="Obra"
        previous_section="Home"
        previous_url="/"
      />
      <div id="photos-works">
        <vue-load-image v-for="(work, index) in works" :key="work.pk" class="image-container">
          <div 
            slot="preloader" 
            class="skeleton-loader"
            :style="{ animationDelay: (index * 0.15) + 's' }"
          ></div>
          <img
            slot="image"
            class="image-gallery-works"
            :src="resolve_img_server(work.cover)"
            alt="index"
            @click="showGallery(work)"
          />
        </vue-load-image>
      </div>
    </div>
    <div v-if="image.visible" id="gallery-works">
      <div id="background-gallery-works" />
      <div 
        id="navigation-left" 
        @click="leftImage"
        class="navigation-button"
      >
        <img src="@/assets/works/cursor-izq.png" height="40px" alt="Previous" />
      </div>
      <div 
        id="navigation-right" 
        @click="rightImage"
        class="navigation-button"
      >
        <img src="@/assets/works/cursor-der.png" height="40px" alt="Next" />
      </div>
      <div 
        id="image-works"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <div v-if="image.id_video">
          <img
            v-if="!vimeo_ready"
            alt="Cargando..."
            src="@/assets/gallery/loading.png"
            height="35px"
          />
          <vue-vimeo-player
            :video-id="image.id_video"
            player-height="640px"
            @ready="onVimeoReady"
          />
        </div>
        <vue-load-image v-else>
          <img
            slot="preloader"
            alt="Cargando..."
            src="@/assets/gallery/loading.png"
            height="35px"
          />
          <img
            slot="image"
            id="center-image-works"
            :src="resolve_img_server(image.path)"
            :alt="index"
          />
        </vue-load-image>
      </div>
      <div id="gallery-info-container-works-cellphone">
        <div id="container-gallery-counter-works">
          <img
            :src="this.resolve_img_url('cursor-izq.png')"
            height="17px"
            @click="leftImage"
            class="left-image-clicker"
          />
          <div id="gallery-counter-works">
            <img
              v-for="i in quantity_images"
              class="circle-image"
              :src="getCircle(i)"
              :key="i"
              height="17px"
              alt=""
              @click="go_to_image(i)"
            />
          </div>
          <img
            :src="this.resolve_img_url('cursor-der.png')"
            height="17px"
            @click="rightImage"
            class="right-image-clicker"
          />
        </div>
        <div id="gallery-text-works">{{ image.title }}</div>
        <div id="text-description-works">
          <vue-marked>
            {{ actual_work.description }}
            {{ image.extra_description }}
          </vue-marked>
        </div>
      </div>
      <div id="gallery-info-container-works">
        <div id="gallery-counter-works">
          <img
            v-for="i in quantity_images"
            class="circle-image"
            :src="getCircle(i)"
            :key="i"
            height="17px"
            alt=""
            @click="go_to_image(i)"
          />
        </div>
        <div id="gallery-text-works">{{ image.title }}</div>
        <div id="gallery-info-works" @click="showDescription">
          <a href="#">info</a>
        </div>
      </div>
      <div
        id="gallery-description-works"
        v-show="show_description"
        @mousemove="restoreMouse"
      >
        <div id="close-description" @click="closeDescription">
          <img
            class="close-description-image"
            alt="Cerrar"
            src="@/assets/gallery/cruz_info.png"
            height="30px"
          />
        </div>
        <div id="text-description-works">
          <vue-marked>
            {{ actual_work.description }}
            {{ image.extra_description }}
          </vue-marked>
        </div>
      </div>
      <div
        id="close_image-works"
        @click="hideGallery"
        @mousemove="restoreMouse"
      >
        <img alt="Cerrar" src="@/assets/gallery/cruz.png" height="30px" />
      </div>
    </div>
  </div>
</template>

<script>
import NavigatorWork from "@/components/NavigatorWork.vue";
import { vueVimeoPlayer } from "vue-vimeo-player";
import VueLoadImage from "vue-load-image";
import VueMarked from "vue-marked";
import axios from "axios";

export default {
  name: "Works",
  components: { NavigatorWork, vueVimeoPlayer, VueLoadImage, VueMarked },
  data: function () {
    return {
      works: [],
      carousel: [],
      image: {
        visible: false,
        path: "",
        title: "",
        description: "",
        id_video: "",
      },
      actual_work: "",
      actual_image_index: 0,
      quantity_images: 0,
      location_cursor: "",
      show_description: false,
      vimeo_ready: false,
      touchStartX: 0,
      touchEndX: 0,
    };
  },
  methods: {
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
    },
    handleTouchMove(event) {
      this.touchEndX = event.changedTouches[0].screenX;
    },
    handleTouchEnd() {
      const swipeThreshold = 50;
      const diff = this.touchStartX - this.touchEndX;
      
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          // Swipe left - next image
          this.rightImage();
        } else {
          // Swipe right - previous image
          this.leftImage();
        }
      }
    },
    getWorks: async function () {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/work/")
          .then((response) => (this.works = response.data));
      } catch (error) {
        console.log(error);
      }
    },
    getWorkItems: async function (id_work) {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/work/items/" + id_work)
          .then((response) => (this.carousel = response.data));
      } catch (error) {
        console.log(error);
      }
    },
    keyup: function(event) {
      const actions = {
        Escape: () => this.hideGallery(),
        ArrowLeft: () => this.leftImage(),
        ArrowRight: () => this.rightImage(),
      };
      const action = actions[event.key];
      if (action) {
        event.preventDefault();
        action();
      }
    },
    showGallery: async function (work) {
      try {
        axios
          .get("https://api.ladraaaaa.com/api/work/items/" + work.pk)
          .then((response) => {
            this.actual_work = work;
            this.carousel = response.data;
            this.image.title = work.title;
            this.image.path = response.data[0].image;
            this.image.extra_description = response.data[0].extra_description;
            this.quantity_images = this.carousel.length;
            this.image.visible = true;
            this.image.id_video = "";
            window.addEventListener("keyup", this.keyup);
          });
      } catch (error) {
        console.log(error);
      }
    },
    hideGallery: function () {
      this.image.visible = false;
      this.show_description = false;
      this.actual_image_index = 0;
      this.carousel.shift();
      this.restoreMouse();
    },
    leftImage: function () {
      let quantity_images = this.carousel.length;
      if (this.actual_image_index === 0) {
        this.actual_image_index = quantity_images - 1;
      } else {
        this.actual_image_index = this.actual_image_index - 1;
      }
      this.image.description = this.actual_work.description;
      this.image.description += "\n";
      this.image.extra_description =
        this.carousel[this.actual_image_index].extra_description;
      this.image.path = this.carousel[this.actual_image_index].image;
      this.image.id_video = this.carousel[this.actual_image_index].id_video;
    },
    rightImage: function () {
      let quantity_images = this.carousel.length;
      if (this.actual_image_index === quantity_images - 1) {
        this.actual_image_index = 0;
      } else {
        this.actual_image_index = this.actual_image_index + 1;
      }
      this.image.extra_description =
        this.carousel[this.actual_image_index].extra_description;
      this.image.path = this.carousel[this.actual_image_index].image;
      this.image.id_video = this.carousel[this.actual_image_index].id_video;
    },
    go_to_image: function (i) {
      this.actual_image_index = i - 1;
      this.image.extra_description =
        this.carousel[this.actual_image_index].extra_description;
      this.image.path = this.carousel[this.actual_image_index].image;
      this.image.id_video = this.carousel[this.actual_image_index].id_video;
    },
    restoreMouse: function () {
      document.body.style.cursor = "default";
      this.location_cursor = "";
    },
    onVimeoReady() {
      this.vimeo_ready = true;
    },
    showDescription: function () {
      this.show_description = true;
    },
    closeDescription: function () {
      this.show_description = false;
    },
    updateInfoLinks: function () {
      this.$nextTick(() => {
        const containers = document.querySelectorAll(
          "#gallery-works #text-description-works"
        );
        containers.forEach((container) => {
          const links = container.querySelectorAll("a[href]");
          links.forEach((link) => {
            link.setAttribute("target", "_blank");
            link.setAttribute("rel", "noopener noreferrer");
          });
        });
      });
    },
    getCircle: function (i) {
      i = i - 1;
      let images = require.context(
        "../assets/gallery/",
        false,
        /\.png$|\.jpg$|\.gif/
      );
      if (i === this.actual_image_index) {
        return images(`./${"circulo_relleno.png"}`);
      } else {
        return images(`./${"circulo.png"}`);
      }
    },
    resolve_img_server: function (path) {
      const url = "https://api.ladraaaaa.com/" + path;
      // TODO: REMOVE THIS DELAY - Only for testing skeleton loader
      // return url + "?delay=" + Math.random();
      return url;
    },
    resolve_img_url: function (path) {
      if (path === "") {
        return "";
      }
      let images = require.context(
        "../assets/works/",
        false,
        /\.png$|\.jpg$|\.gif/
      );
      return images(`./${path}`);
    },
  },
  created() {
    this.getWorks();
    document.body.style.background = "#ffffff";
    document.body.style.overflowY = "scroll;";
  },
  watch: {
    show_description(newVal) {
      if (newVal && this.image.visible) {
        this.$nextTick(() => {
          this.updateInfoLinks();
        });
      }
    },
    "image.description"(newVal, oldVal) {
      if (this.image.visible && this.show_description && newVal !== oldVal) {
        this.$nextTick(() => {
          this.updateInfoLinks();
        });
      }
    },
    "actual_work.description"(newVal, oldVal) {
      if (this.image.visible && this.show_description && newVal !== oldVal) {
        this.$nextTick(() => {
          this.updateInfoLinks();
        });
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Paprika&display=swap");

body {
  margin-top: 66px;
  margin-left: 33px;
  margin-right: 33px;
}

a {
  color: #03ff00;
}

#background-gallery-works {
  background: rgba(255, 255, 255, 0.85);
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  position: fixed;
}

#center-image-works {
  max-height: 640px;
}

#image-works {
  z-index: 99;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

#gallery-text-works {
  z-index: 99;
  color: #03ff00;
  font-size: 18px;
  font-family: "Paprika", regular, serif;
}

#gallery-info-works {
  font-size: 18px;
}

#gallery-description-works {
  z-index: 120;
  position: fixed;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 24px;
  font-family: "Paprika", regular, serif;
  color: black;
  height: 500px;
  width: 1050px;
  text-align: justify;
}

#text-description-works {
  height: 100%;
  overflow-y: scroll;
  color: #000;
  background: rgba(255,255,255,0.8); /* prev 0.4 */
}

#gallery-info-container-works {
  z-index: 120;
  color: #03ff00;
  font-size: 17px;
  font-family: "Paprika", regular, serif;
  bottom: 40px;
  left: 50%;
  position: fixed;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: space-between;
  width: 600px;
}

#photos-works {
  padding-top: 100px;
  margin-left: 43px;
  margin-right: 43px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px 20px;
  justify-items: center;
  align-items: stretch;
}

.image-container {
  width: 100%;
  min-width: 350px;
  display: block;
}

.image-gallery-works {
  width: 100%;
  height: auto;
  aspect-ratio: 4/3;
  object-fit: cover;
  margin: 0;
  cursor: pointer;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  display: block;
}
.image-gallery-works:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 24px rgba(0,0,0,0.15);
}

.skeleton-loader {
  width: 100%;
  aspect-ratio: 4/3;
  background: #e0e0e0;
  border-radius: 8px;
  animation: pulse 1s ease-in-out infinite;
  display: block;
}

@keyframes pulse {
  0%, 100% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
}

.navigation-button {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 101;
  cursor: pointer;
  padding: 20px;
  transition: opacity 0.2s;
  opacity: 0.7;
}

.navigation-button:hover {
  opacity: 1;
}

#navigation-left {
  left: 20px;
}

#navigation-right {
  right: 20px;
}

#close_image-works {
  cursor: pointer;
  z-index: 100;
  position: fixed;
  top: 4%;
  right: 4%;
}

.close-description-image {
  cursor: pointer;
}

#close-description {
  text-align: start;
}

#gallery-counter-works {
  align-self: center;
  margin-top: 3px;
}

.circle-image {
  cursor: pointer;
}

#gallery-info-container-works-cellphone {
  display: none;
}

@media only screen and (max-width: 1024px) {
  .navigation-button {
    display: none;
  }

  .image-container {
    min-width: 300px;
  }

  #center-image-works,
  iframe {
    display: block;
    margin-left: auto;
    margin-right: auto;
    max-width: 90vw;
    max-height: 60vh;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  #image-works {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: fixed;
    z-index: 99;
  }

  #gallery-info-container-works {
    width: 90vw;
    max-width: 500px;
    left: 50%;
    bottom: 20px;
    transform: translateX(-50%);
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 15px;
    z-index: 120;
    background: rgba(0,0,0,0.8);
    color: #03ff00;
    border-radius: 8px;
    padding: 10px 0;
  }

  #gallery-description-works {
    width: 90vw;
    max-width: 500px;
    height: 50vh;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    z-index: 120;
    border-radius: 8px;
    overflow-y: auto;
  }

  #text-description-works {
    font-size: 14px;
    height: 100%;
    overflow-y: auto;
    padding: 10px;
    border-radius: 6px;
  }
}

@media only screen and (max-width: 768px) {
  #center-image-works,
  iframe {
    max-width: 98vw;
    max-height: 45vh;
  }

  #gallery-info-container-works {
    max-width: 98vw;
    font-size: 13px;
    padding: 8px 0;
  }

  #gallery-description-works {
    max-width: 98vw;
    height: 45vh;
    font-size: 14px;
  }

  #text-description-works {
    font-size: 12px;
    padding: 8px;
  }
}

@media only screen and (max-width: 450px) {
  body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
  }

  #gallery-description-works {
    position: fixed;
    left: 50%;
    top: 50%;
    width: 90vw;
    height: 70vh;
    z-index: 300;
    background: rgba(255,255,255,0.97);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 0;
    margin: 0;
    font-size: 13px;
    border-radius: 12px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    box-shadow: 0 2px 16px rgba(0,0,0,0.12);
  }

  #close-description {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 310;
  }

  .close-description-image {
    cursor: pointer;
    width: 28px;
    height: 28px;
  }

  #text-description-works {
    width: 92vw;
    max-width: 100%;
    max-height: 60vh;
    margin-top: 40px;
    overflow-y: auto;
    background: transparent;
    color: #000;
    font-size: 12px;
    padding: 8px;
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;
    display: block;
  }

  #photos-works {
    padding-top: 30px;
    margin-left: 8px;
    margin-right: 8px;
    gap: 12px 0;
  }

  .image-container {
    width: 100%;
    min-width: 0;
  }

  .image-gallery-works {
    border-radius: 4px;
  }
}
</style>
